const secondaryColors = {
    ['secondary-01']: '#9B9AC8',
    ['secondary-02']: '#AFACFD',
    ['secondary-03']: '#CDCCFA',
    ['secondary-04']: '#E1E1FF',
    ['secondary-05']: '#E6E5FF',
    ['secondary-06']: '#F1F1FF',
    ['secondary-07']: '#F8F8FF',
    ['secondary-08']: '#8399C6',
    ['secondary-09']: '#99B0DD',
    ['secondary-10']: '#ECF0FD',
    ['secondary-11']: '#4A8EEF',
    ['secondary-12']: '#9D9BDA',
    ['secondary-13']: '#F7F9FF',
    ['secondary-14']: '#757CD4',
};
const primaryColors = {
    ['primary-01']: '#0054F7',
    ['primary-02']: '#002774',
};
const semanticColors = {
    ['semantic_high-risk']: '#E34646',
    ['semantic_medium-risk']: '#E3A446',
    ['semantic_low-risk']: '#13B7B7',
};
export const colors = {
    primary: primaryColors,
    secondary: secondaryColors,
    semantic: semanticColors
};
//# sourceMappingURL=colors.js.map